import { Component, inject, OnInit } from '@angular/core';
import { BannerService } from './banner.service';
import { CommonModule } from '@angular/common';
import { NRIconComponent } from '../nr-icon/nr-icon.component';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'nr-banner',
  imports: [CommonModule, NRIconComponent],
  templateUrl: './nr-banner.component.html',
  styleUrl: './nr-banner.component.scss',
})
export class NrBannerComponent implements OnInit {
  banners: { message: string; context: string; type: string, showCloseIcon?: boolean }[] = [];
  private router = inject(Router);
  showBanner? : boolean = true;
  bannerStyles = {
    success: {
      background: '#D4EDDA',
      border: '#87BB92',
    },
    warning: {
      background: '#FDF8E8',
      border: '#E4B720',
    },
    error: {
      background: '#F7E4E7',
      border: '#BB0723',
    },
    info: {
      background: '#D4E9FF',
      border: '#9EC1E6',
    },
  };

  constructor(private bannerService: BannerService) {}

  ngOnInit(): void {
    // Clear banners on route change
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.banners = [];
      }
    });

    this.bannerService.banner$.subscribe((banner) => {
      this.banners = [];
      this.banners.push(banner);
      this.showBanner = banner.showBanner !== false; // default to true if undefined
    });
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return 'success-icon';
      case 'warning':
        return 'warning-icon';
      case 'error':
        return 'error-icon';
      default:
        return 'info-icon';
    }
  }

  getBannerStyle(type: string): { [key: string]: string } {
    const style = this.bannerStyles[type] || this.bannerStyles['info'];
    return {
      'background-color': style.background,
      border: `1px solid ${style.border}`,
    };
  }

  bannerClose(event: Event, context: string) {
    event.preventDefault();
    this.banners = [];
    this.showBanner = false;
    this.bannerService.dismissBanner(context, true);
  }
}
